// extracted by mini-css-extract-plugin
export var popover = "popover-module--popover--G3wUb";
export var slideUp = "popover-module--slideUp--LSy7q";
export var popover__wrapper = "popover-module--popover__wrapper--EiSqk";